import { buildURL } from '../../webservice';
import axios from 'axios';

type Params = {
    isActive?: boolean;
    isPublic?: boolean;
};

type Auth = {
    token: string;
};

const BASE_URL = process.env.REACT_APP_PAYMENTS_API_URL as string;

export const getGateways = async (params: Params, { token }: Auth) => {
    try {
        const queryParams = new URLSearchParams(params as any);
        const url = buildURL(BASE_URL, '/v2/gateways', queryParams);
        const response = await axios.get(url, {
            headers: { Authorization: `Bearer ${token}` },
        });

        return response.data;
    } catch (err) {
        console.error('Error getting gateways: ', err);
        return [];
    }
};
